const keyword = 'STATE_STATES';

const constants = {
  FETCH_SUPPORTED_STATES: `${keyword}/FETCH_SUPPORTED_STATES`,
  RECEIVE_SUPPORTED_STATES_DONE: `${keyword}/RECEIVE_SUPPORTED_STATES_DONE`,
};

export default constants;
